import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const AttendnaceSectionViewLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'AttendnaceSectionView' */ './components/AttendanceSectionView'
		)
);

export default (store) => {
	return [
		{
			path: 'home/attendance-dashboard/section-view/:sectionId',
			element: <AsyncLoading component={<AttendnaceSectionViewLazy />} />,
		},
	];
};
